import React from 'react';
import { MDBSpinner } from 'mdb-react-ui-kit';

export default function Loading() {
  return (
    <div className="jumbotron d-flex align-items-center min-vh-100">
      <div className="container text-center text-white text-4xl">
        <MDBSpinner  style={{cursor: 'none'}} role='status' tag='span' className='me-2' />
        Carregando...
      </div>
    </div>
  );
}